import { X, BookOpen } from 'lucide-react'
import type { HelpPage } from '@/help/helpContent'

interface Props {
  content: HelpPage
  onClose: () => void
}

export default function HelpDrawer({ content, onClose }: Props) {
  return (
    <>
      {/* Полупрозрачный фон */}
      <div className="fixed inset-0 z-40 bg-black/20" onClick={onClose} />

      {/* Панель */}
      <div className="fixed right-0 top-0 bottom-0 z-50 w-80 bg-white shadow-2xl border-l border-gray-200 flex flex-col">
        {/* Шапка */}
        <div className="flex items-center gap-2 px-4 py-3 border-b border-gray-100 bg-brand-50">
          <BookOpen className="h-4 w-4 text-brand-600 flex-shrink-0" />
          <h2 className="text-sm font-semibold text-brand-700 flex-1 truncate">{content.title}</h2>
          <button
            onClick={onClose}
            className="rounded-lg p-1 text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
          >
            <X className="h-4 w-4" />
          </button>
        </div>

        {/* Содержимое */}
        <div className="flex-1 overflow-y-auto px-4 py-4 space-y-3">
          {content.intro && (
            <p className="text-sm text-gray-600 leading-relaxed">{content.intro}</p>
          )}
          {content.sections.map((s, i) => (
            <div key={i} className="rounded-lg bg-gray-50 border border-gray-100 p-3">
              <h3 className="text-xs font-semibold text-gray-700 mb-1">{s.heading}</h3>
              <p className="text-xs text-gray-600 leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>

        <div className="px-4 py-3 border-t border-gray-100 text-center">
          <p className="text-xs text-gray-400">Нажмите ? для интерактивного тура по экрану</p>
        </div>
      </div>
    </>
  )
}
